import React, { useState } from 'react'

export const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.id)

  return (
    <div className="custom-tabs">
      <div>
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab-content ${
              activeTab === tab.id ? 'active-tab' : 'inactive-tab'
            }`}
          >
            {tab.content}
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <div className="flex flex-row justify-between tab-controler-wrapper">
          {tabs.map((tab) => (
            <button
              aria-label="tab-controler"
              key={tab.id}
              className={`tab-controler font-semibold ${
                activeTab === tab.id
                  ? 'active-tab-controler'
                  : 'inactive-tab-controler'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
